import { render, staticRenderFns } from "./NewLanguageModal.vue?vue&type=template&id=20abca24"
import script from "./NewLanguageModal.vue?vue&type=script&lang=js"
export * from "./NewLanguageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports